const Heading = {
  baseStyle: ({ fontFamily }) => ({
    lineHeight: [1, null, 1.2],
    fontWeight: fontFamily === "heading" ? "normal" : "bold",
    mb: 0,
  }),
  sizes: {
    "4xl": {
      fontSize: ["6xl", null, "7xl"],
      lineHeight: [1, null, 1.2],
    },
    "3xl": {
      fontSize: ["5xl", null, "6xl"],
      lineHeight: [1, null, 1.2],
    },
    "2xl": {
      fontSize: ["4xl", null, "5xl"],
      lineHeight: [1, null, 1.2],
    },
    xl: {
      fontSize: ["3xl", null, "4xl"],
      lineHeight: [1, null, 1.2],
    },
    lg: {
      fontSize: ["2xl", null, "3xl"],
      lineHeight: [1, null, 1.2],
    },
    md: { fontSize: "xl", lineHeight: [1, null, 1.2] },
    sm: { fontSize: "md", lineHeight: [1, null, 1.2] },
    xs: { fontSize: "sm", lineHeight: [1, null, 1.2] },
  },
  defaultProps: {
    fontFamily: "heading",
  },
};

export default Heading;
